// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import CouponReducer from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.reducer';
import CouponSaga from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.saga';
import {
  getIsBonusPointDayEnabled,
  getcouponOnHoldNewDesign,
  getIsCouponSmoothScrollEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import BagPageSelector from '../../../../../CnC/BagPage/container/BagPage.selectors';
import BAG_PAGE_ACTIONS from '../../../../../CnC/BagPage/container/BagPage.actions';
import { getCouponList } from '../../../../../CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import CouponAndPromos from '../../../../../CnC/common/organism/CouponAndPromos';
import { getCouponFetchingState } from '../../../../../CnC/common/organism/CouponAndPromos/container/Coupon.selectors';

export class MyOffersCouponsContainer extends PureComponent {
  componentDidMount() {
    const {
      needHelpContent,
      fetchNeedHelpContent,
      fetchCoupons,
      fetchCouponsCached,
      isCouponFetching,
      couponSelfHelp,
      isAccountDrawer,
      isAccountDashboard,
      isPlacePerks,
      isPlacePerkEnabled,
      couponOnHoldNewDesign,
      getCartCachedData,
    } = this.props;
    fetchNeedHelpContent([needHelpContent]);
    if (!isCouponFetching) {
      if (isAccountDrawer || isAccountDashboard || (isPlacePerks && isPlacePerkEnabled)) {
        fetchCouponsCached(couponSelfHelp, isAccountDrawer);
      } else {
        fetchCoupons(couponSelfHelp);
      }
    }
    if (couponOnHoldNewDesign) {
      getCartCachedData();
    }
  }

  render() {
    const {
      closedOverlay,
      couponSelfHelp,
      isAccountDrawer,
      isAccountDashboard,
      isPlacePerks,
      isPlacePerkEnabled,
      isWallet,
      couponOnHoldNewDesign,
      fromPlaceRewards,
      isBonusPointDayEnabled,
      isCouponSmoothScrollEnabled,
    } = this.props;
    return (
      <CouponAndPromos
        showAccordian={false}
        isCarouselView
        closedOverlay={closedOverlay}
        fromCartPage="false"
        couponSelfHelp={couponSelfHelp}
        isAccountDrawer={isAccountDrawer}
        isAccountDashboard={isAccountDashboard}
        isPlacePerks={isPlacePerks}
        isPlacePerkEnabled={isPlacePerkEnabled}
        isWallet={isWallet}
        couponOnHoldNewDesign={couponOnHoldNewDesign}
        fromPlaceRewards={fromPlaceRewards}
        isBonusPointDayEnabled={isBonusPointDayEnabled}
        isCouponSmoothScrollEnabled={isCouponSmoothScrollEnabled}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  fetchNeedHelpContent: (contentIds) => {
    dispatch(BAG_PAGE_ACTIONS.fetchModuleX(contentIds));
  },
  getCartCachedData: () => {
    dispatch(BAG_PAGE_ACTIONS.getCachedCartData({ skipInventoryCall: true }));
  },
  fetchCoupons: (couponSelfHelp) => {
    dispatch(getCouponList({ fromCSH: couponSelfHelp, ignoreCache: true }));
  },
  fetchCouponsCached: (couponSelfHelp, isAccountDrawer) => {
    dispatch(getCouponList({ fromCSH: couponSelfHelp, isAccountDrawer }));
  },
});

export const mapStateToProps = (state) => ({
  needHelpContent: BagPageSelector.getNeedHelpContent(),
  isCouponFetching: getCouponFetchingState(state),
  couponOnHoldNewDesign: getcouponOnHoldNewDesign(state),
  isBonusPointDayEnabled: getIsBonusPointDayEnabled(state),
  isCouponSmoothScrollEnabled: getIsCouponSmoothScrollEnabled(state),
});

MyOffersCouponsContainer.propTypes = {
  fetchCoupons: PropTypes.func.isRequired,
  closedOverlay: PropTypes.func,
  fetchNeedHelpContent: PropTypes.func.isRequired,
  needHelpContent: PropTypes.string,
  isCouponFetching: PropTypes.bool,
  couponSelfHelp: PropTypes.bool,
  isAccountDrawer: PropTypes.bool,
  isAccountDashboard: PropTypes.bool,
  isPlacePerks: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
};

MyOffersCouponsContainer.defaultProps = {
  closedOverlay: () => {},
  needHelpContent: '',
  isCouponFetching: false,
  couponSelfHelp: false,
  isAccountDrawer: false,
  isAccountDashboard: false,
  isPlacePerks: false,
  isPlacePerkEnabled: false,
};

const withReducer = withDynamicReducer([{ key: 'CouponsAndPromos', reducer: CouponReducer }]);
const withSaga = withDynamicSaga([{ key: 'CouponSaga', saga: CouponSaga }]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(MyOffersCouponsContainer);
